import React from "react";

// antrian_terlewat dibatasi config.antrian_terlewat_count, sedangkan passed_count
// adalah total sebenarnya. Selisihnya ditampilkan tanpa menambah nama pasien.
const PassedQueueMore = ({ passedCount, shownCount }) => {
  const hiddenCount = (passedCount ?? 0) - shownCount;
  if (hiddenCount <= 0) return null;
  return <p className="queue-passed-more">+{hiddenCount} lainnya</p>;
};

export default PassedQueueMore;
